@if (data()) {
  <div class="confirm-dialog">
    <div class="confirm-dialog__header">
      <h2 class="confirm-dialog__title">{{ data()!.title }}</h2>
    </div>
    <div class="confirm-dialog__content">
      <p class="confirm-dialog__message">{{ data()!.message }}</p>
    </div>
    <div class="confirm-dialog__actions">
      <htx-button variant="tertiary" (click)="cancel()">
        {{ data()!.cancelText || 'Abbrechen' }}
      </htx-button>
      <htx-button variant="danger" (click)="confirm()">
        {{ data()!.confirmText || 'Bestätigen' }}
      </htx-button>
    </div>
  </div>
}
